<div class="suggestion-container" *ngIf="isVisible" [style.top]="topPosition">
    <!-- TODO: Future Coveo Suggestions -->
    <!-- <div class="coveo-suggestions" *ngIf="showCoveoSuggestions && suggestions?.length > 0">
        <mat-autocomplete #auto="matAutocomplete">
            <mat-option *ngFor="let suggestion of suggestions" [value]="suggestion.rawValue">
                {{ suggestion.rawValue }}
            </mat-option>
        </mat-autocomplete>
    </div> -->

    <div class="suggestion-grid">
        <div class="recent-searches">
            <app-recently-search-facet id="recently-search" (afterSearch)="onFacetItemClick(false)">
            </app-recently-search-facet>
        </div>
        <div class="divider"></div>
        <div class="recent-views">
            <app-recently-viewed-facet (afterItemClick)="onFacetItemClick(true)"> </app-recently-viewed-facet>
        </div>
    </div>
</div>
